import { graphql, useStaticQuery } from 'gatsby';

const usePortafolio = () => {

    const data = useStaticQuery(graphql`
        query {
            allDatoCmsPortafolio(filter: {}) {
                nodes {
                    titulo,
                    categoria,
                    link,
                    slug,
                    imagen {
                        fluid(maxWidth: 1200) {
                            ...GatsbyDatoCmsFluid
                        }
                    }
                    descripcion,
                    categorias,
                    date,
                    industria
                }
            }
        }
    `);

    return data.allDatoCmsPortafolio.nodes.map(portafolio => ({
        titulo: portafolio.titulo,
        categoria: portafolio.categoria,
        link: portafolio.link,
        slug: portafolio.slug,
        imagen: portafolio.imagen,
        descripcion: portafolio.descripcion,
        categorias: portafolio.categorias,
        date: portafolio.date,
        industria: portafolio.industria
    }));
}
 
export default usePortafolio;